// import React, { useEffect, useRef, useState } from "react";
// import ReactPaginate from "react-paginate";
// import { CSVLink } from "react-csv";
// import { Route, useLocation } from "react-router-dom";
// import * as XLSX from "xlsx";
// import Button from "../CommonComponent/Button";
// import UploadBulkStaffData from "./UploadBulkStaffData";

// import Records from "./Records";
// import useHttp from "../../Hooks/use-http";
// import CorporateFilter from "../CommonComponent/CorporateFilter";
// import ExcelJS from "exceljs";
// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import { saveAs } from "file-saver";
// import {
//   Autocomplete,
//   Box,
//   Modal,
//   TablePagination,
//   TextField,
//   Typography,
// } from "@mui/material";
// import CommonTablePagination from "../CommonComponent/CommonTablePagination";
// import { useHistory } from "react-router-dom";

// const STAFF_TITLE = [
//   "Name",
//   "Department",
//   // "Pickup Address",
//   // "Pickup Route",
//   "Pickup Address (Route)",

//   // "Drop Address",
//   // "Drop Route",
//   "Drop Address (Route)",
//   "Status",
//   "QR Code",
// ];

// const STAFF_TITLE_WITH_CORPORATE = [
//   "Name",
//   "Corporate Name",
//   "Department",
//   "Pickup Address (Route)",
//   // "Pickup Route",
//   "Drop Address (Route)",
//   // "Drop Route",
//   "Status",
//   "QR Code",
// ];

// let myClick = false;
// let prev_id = "1";
// let staffListFlag = 0;
// let staff_details = [];

// const Alert = React.forwardRef(function Alert(props, ref) {
//   return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
// });
// function Routes() {
//   // const [currentPage, setCurrentPage] = useState(1);
//   // const [recordsPerPage] = useState(7);
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(7);
//   const [filteredData, setFilteredData] = useState([]);

//   const [isUploadFileClicked, setIsUploadFileClicked] = useState(false);
//   const [isRequest, setIsRequest] = useState(false);
//   const [corporateData, setCorporateData] = useState([]);
//   const [headers, setHeaders] = useState(STAFF_TITLE);
//   const [modalOpen, setModalOpen] = useState(false);
//   const history = useHistory();
//   // const [selectCorporateForBulk, setSelectCorporateForBulk] = useState({
//   //   cpName: "",
//   //   cpId: "",
//   // });

//   const [selectedCorporateDetails, setSelectedCorporateDetails] = useState({
//     cpName: "",
//     cpId: "",
//   });

//   useEffect(() => {
//     if (localStorage.getItem("roleId") != 1) {
//       setSelectedCorporateDetails({
//         cpName: localStorage.getItem("cpName"),
//         cpId: localStorage.getItem("corpId"),
//       });
//     }
//   }, []);

//   const searchInputRef = useRef();

//   const search = useLocation().search;
//   const id = new URLSearchParams(search).get("departmentId");

//   // console.log("myID", id);

//   const authenticateUser = (data) => {
//     // console.log(data);

//     let staff_data = [];
//     if (data?.corporateRiders) {
//       for (let i = 0; i < data?.corporateRiders?.length; i++) {
//         staff_data.push({
//           id: i + 1,
//           name: data.corporateRiders[i].riderName,
//           mobile_no: data.corporateRiders[i].mobileNumber,
//           // superviser_name: data.corporateRiders[i].SupervisorName,

//           department: data.corporateRiders[i].corporateName,
//           // status: data.corporateRiders[i].Status,
//           status: "Active",

//           corporateName: data.corporateRiders[i].corporateName,
//           departmentName: data.corporateRiders[i]?.dptName,
//           pickupAddress: data.corporateRiders[i].pickupAddress,
//           pickupRouteName: data.corporateRiders[i].PickupRouteName,
//           pickupLL: data.corporateRiders[i].pickupLL,
//           dropAddress: data.corporateRiders[i].dropAddress,
//           // dropRouteName: data.corporateRiders[i].DropRouteName,
//           dropRouteName: null,

//           dropLL: data.corporateRiders[i].dropLL,
//           corporateId: data.corporateRiders[i].corporateID,
//           uniqueNumber: data.corporateRiders[i].uniqueNumber,
//           RiderImage: data.corporateRiders[i].imageURL,
//         });
//       }
//     }
//     staff_details = staff_data;
//     setFilteredData(staff_data);
//   };

//   useEffect(() => {
//     if (localStorage.getItem("roleId") === "1") {
//       setHeaders(STAFF_TITLE_WITH_CORPORATE);
//     } else {
//       setHeaders(STAFF_TITLE);
//     }
//   }, []);

//   const { isLoading, sendRequest } = useHttp();

//   useEffect(() => {
//     // if (staffListFlag > 0)
//     sendRequest(
//       {
//         url: "/corporateriders",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           emailID: localStorage.getItem("user"),
//           // corporateID: id ? id : "",
//         },
//       },
//       authenticateUser
//     );
//     staffListFlag++;
//   }, [sendRequest, id, isRequest]);

//   const nPages = Math.ceil(filteredData?.length / rowsPerPage);

//   let fromRecords = 0;
//   if (page === 0) fromRecords = 1;
//   else fromRecords = page * rowsPerPage;
//   let toRecords = 0;
//   if (
//     (myClick
//       ? page * rowsPerPage - (filteredData?.length % rowsPerPage)
//       : page * rowsPerPage +
//         rowsPerPage -
//         (filteredData?.length % rowsPerPage)) > filteredData?.length
//   )
//     toRecords = filteredData?.length;
//   else toRecords = page * rowsPerPage;
//   if (toRecords === 0) fromRecords = 0;
//   if (page === nPages) toRecords = filteredData?.length;

//   const routeSearchHandler = (e) => {
//     // if (e.target.value)
//     setFilteredData(
//       staff_details.filter(
//         (data) =>
//           data.name?.toLowerCase().includes(e.target.value.toLowerCase()) ||
//           data.mobile_no
//             ?.toLowerCase()
//             .includes(e.target.value.toLowerCase()) ||
//           data.superviser_name
//             ?.toLowerCase()
//             .includes(e.target.value.toLowerCase()) ||
//           data.department
//             ?.toLowerCase()
//             .includes(e.target.value.toLowerCase()) ||
//           data.status?.toLowerCase().includes(e.target.value.toLowerCase())
//       )
//     );
//     // else setFilteredData(TRIP_DATA);
//   };
//   const handleOpenModal = () => setModalOpen(true);
//   const handleCloseModal = () => setModalOpen(false);
//   const handleCloseAddTaskModal = () => {
//     setModalOpen(false);
//     // setSelectedCorporate([]);
//   };

//   const handleCorporateChange = (event, newValue) => {
//     if (newValue) {
//       const selectedData = corporateData.filter(
//         (data) => data?.cpName === newValue
//       );
//       setSelectedCorporateDetails(selectedData[0] || { cpName: "", cpId: "" });
//     } else {
//       setSelectedCorporateDetails({ cpName: "", cpId: "" });
//     }
//   };

//   // Handle bulk upload click
//   const handleBulkUploadClick = () => {
//     setIsUploadFileClicked(true);
//     setModalOpen(false); // Close modal on click
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Calculate pagination
//   const indexOfLastRecord = page * rowsPerPage + rowsPerPage;
//   const indexOfFirstRecord = page * rowsPerPage;
//   const currentRecords = filteredData.slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );

//   // 99999999999999999999999999999999999999999999999999999999999999
//   const [isFileParsingError, setIsFileParsingError] = useState({
//     status: false,
//     message: "",
//   });
//   console.log("🚀 ~ isFileParsingError: 90090909", isFileParsingError);
//   const [isUploadClicked, setIsUploadClicked] = useState(false);
//   const [staffData, setStaffData] = useState([]);
//   console.log("🚀 ~ staffData: 90090909", staffData);
//   const [isSuccess, setIsSuccess] = useState(false);
//   // const { isLoading, sendRequest } = useHttp();
//   const [departmentList, setDepartmentList] = useState(null);
//   const [stopList, setStopList] = useState(null);

//   const generateSampleExcel = async () => {
//     // Check if required data is loaded
//     if (!stopList || !departmentList) {
//       setIsFileParsingError({
//         status: true,
//         message:
//           "Corporate data is still loading. Please try again in a moment.",
//         isAttachementAvailable: false,
//       });
//       return;
//     }

//     const workbook = new ExcelJS.Workbook();
//     const worksheet = workbook.addWorksheet("Staff Data");

//     // Define columns with headers
//     worksheet.columns = [
//       { header: "First Name", key: "firstName", width: 15 },
//       { header: "Last Name", key: "lastName", width: 15 },
//       {
//         header: "Mobile Number (With Country Code without +)",
//         key: "mobile",
//         width: 25,
//       },
//       { header: "Department", key: "department", width: 15 },
//       { header: "Address", key: "address", width: 25 },
//       { header: "Pincode", key: "pincode", width: 10 },
//       { header: "Area", key: "area", width: 15 },
//       { header: "City", key: "city", width: 15 },
//       { header: "State", key: "state", width: 15 },
//       { header: "Pickup Stop", key: "pickupStop", width: 20 },
//       { header: "Drop Stop", key: "dropStop", width: 20 },
//       { header: "Pickup LatLng", key: "pickupLatLng", width: 15 },
//       { header: "Drop LatLng", key: "dropLatLng", width: 15 },
//     ];

//     // Add one empty row
//     worksheet.addRow({});

//     // Department options
//     const departmentOptions = departmentList?.map(
//       (dept) => `${dept.name}(${dept.corporateID})`
//     );
//     const stopOptions = stopList.map((stop) => stop.StopName);

//     // Create a hidden sheet for stop data
//     const stopSheet = workbook.addWorksheet("StopData");

//     stopSheet.addRow(["StopName", "StopLL"]);
//     stopList.forEach((stop) =>
//       stopSheet.addRow([stop.StopName, stop.StopLatlong])
//     );

//     for (let row = 2; row <= 100; row++) {
//       // Department dropdown
//       worksheet.getCell(`D${row}`).dataValidation = {
//         type: "list",
//         allowBlank: true,
//         formulae: [`"${departmentOptions.join(",")}"`],
//         showInputMessage: true,
//         prompt: "Please select a department",
//         showErrorMessage: true,
//         error: "Invalid selection",
//         errorTitle: "Invalid Department",
//       };

//       // Pickup Stop dropdown
//       worksheet.getCell(`J${row}`).dataValidation = {
//         type: "list",
//         allowBlank: true,
//         formulae: [`StopData!$A$2:$A$${stopOptions.length + 1}`],
//         showInputMessage: true,
//         prompt: "Please select a pickup stop",
//         showErrorMessage: true,
//         error: "Invalid selection",
//         errorTitle: "Invalid Pickup Stop",
//       };

//       // Drop Stop dropdown
//       worksheet.getCell(`K${row}`).dataValidation = {
//         type: "list",
//         allowBlank: true,
//         formulae: [`StopData!$A$2:$A$${stopOptions.length + 1}`],
//         showInputMessage: true,
//         prompt: "Please select a drop stop",
//         showErrorMessage: true,
//         error: "Invalid selection",
//         errorTitle: "Invalid Drop Stop",
//       };
//       worksheet.getCell(`L${row}`).value = {
//         formula: `IFERROR(VLOOKUP(J${row}, StopData!A:B, 2, FALSE), "")`,
//       };
//       worksheet.getCell(`M${row}`).value = {
//         formula: `IFERROR(VLOOKUP(K${row}, StopData!A:B, 2, FALSE), "")`,
//       };
//     }

//     // Style the header row
//     worksheet.getRow(1).eachCell((cell) => {
//       cell.font = { bold: true };
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "FFD3D3D3" },
//       };
//     });

//     // Generate Excel file
//     const buffer = await workbook.xlsx.writeBuffer();
//     saveAs(new Blob([buffer]), "staff_sample_data.xlsx");
//   };
//   const addStaffDataResponse = (data) => {
//     if (data.ExistsTripList) {
//       const problematicData = data.ExistsTripList.map((item) => ({
//         "Reason of Rejection": "Mobile Number already registered",
//         "First Name": item.StaffFirstName,
//         "Last Name": item.StaffLastName,
//         "Mobile Number": item.StaffMobileNumber,
//         Department: "",
//         Address: "",
//         Pincode: "",
//         Area: "",
//         City: "",
//         State: "",
//         "Pickup Location": "",
//         "Drop Location": "",
//         "Pickup LatLng": "",
//         "Drop LatLng": "",
//       }));

//       setIsFileParsingError({
//         status: true,
//         message:
//           "Some data are already registered. Please change the mobile number and then upload again",
//         isAttachementAvailable: true,
//         problematicData,
//       });
//     } else {
//       setIsSuccess(true);
//       setModalOpen(false);
//       setIsUploadFileClicked(false);
//     }
//     setIsRequest(true);
//     setModalOpen(false);
//     setIsUploadClicked(false);
//   };

//   useEffect(() => {
//     // Only send the request if corpId is not empty
//     if (selectedCorporateDetails.cpId) {
//       sendRequest(
//         {
//           url: "/corporate",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: {
//               filter: {
//                 corporateID: selectedCorporateDetails.cpId,
//               },
//             },
//           },
//         },
//         corporateStopDetails
//       );
//     }
//   }, [sendRequest, selectedCorporateDetails.cpId]); // Add corpId as a dependency

//   const corporateStopDetails = (data) => {
//     setDepartmentList(data?.departmentLists);
//     setStopList(data?.ShuttleStopList);
//   };
//   console.log("🚀staffs after slice", staffData.slice(1));

//   useEffect(() => {
//     if (isUploadClicked && staffData.length > 0) {
//       const temp = staffData?.slice(1)?.map((row) => ({
//         CorporateID: row[3]?.match(/\(([^)]+)\)/)?.[1] || "",
//         CorporateName: row[3]?.replace(/\s*\([^)]*\)$/, "") || "",
//         StaffFirstName: row[0],
//         StaffLastName: row[1],
//         StaffMobileNumber: row[2],

//         Address: row[4] || "",
//         Pincode: row[5] || "",
//         Area: row[6] || "",
//         City: row[7] || "",
//         State: row[8] || "",
//         PickupStop: row[9] || "",
//         DropStop: row[10] || "",
//         PickupLL: row[11] || "",
//         DropLL: row[12] || "",
//         CorporateType: "cp",
//       }));

//       // Filter out empty rows (where all fields are empty)
//       const filteredTemp = temp.filter(
//         (item) =>
//           item.StaffFirstName ||
//           item.StaffLastName ||
//           item.StaffMobileNumber ||
//           item.CorporateName
//       );
//       sendRequest(
//         {
//           url: "/bulkAddRiders",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             detailsRecord: JSON.stringify(filteredTemp),
//           },
//         },
//         addStaffDataResponse
//       );
//     }
//   }, [isUploadClicked]);

//   const fileChangeHandler = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const fileExt = file.name.split(".").pop().toLowerCase();
//     if (!["xlsx", "csv", "xls"].includes(fileExt)) {
//       setIsFileParsingError({
//         status: true,
//         message: "Please upload file in xlsx, xls or csv format",
//         isAttachementAvailable: false,
//       });
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       try {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: "array" });
//         const worksheet = workbook.Sheets[workbook.SheetNames[0]];
//         const jsonDataTemp = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//         // Check for minimum required columns
//         if (jsonDataTemp.length === 0 || jsonDataTemp[0].length < 3) {
//           setIsFileParsingError({
//             status: true,
//             message: "File is missing required columns",
//             isAttachementAvailable: false,
//           });
//           return;
//         }

//         const jsonData = jsonDataTemp.filter((row) => row[11] && row[12]);

//         // Process data rows
//         const problematicData = [];
//         for (let i = 1; i < jsonData.length; i++) {
//           const row = jsonData[i];
//           if (
//             (!row[0] || !row[1] || !row[2] || !row[3]) &&
//             (row[12] || row[11])
//           ) {
//             problematicData.push({
//               "Reason of Rejection": "Missing required fields",
//               "First Name": row[0] ?? "",
//               "Last Name": row[1] ?? "",
//               "Mobile Number": row[2] ?? "",
//               Department: row[3] ?? "",
//               Address: row[4] ?? "",
//               Pincode: row[5] ?? "",
//               Area: row[6] ?? "",
//               City: row[7] ?? "",
//               State: row[8] ?? "",
//               "Pickup Stop": row[9] ?? "",
//               "Drop Stop": row[10] ?? "",
//               "Pickup LatLng": row[11] ?? "",
//               "Drop LatLng": row[12] ?? "",
//             });
//           }
//         }

//         if (problematicData.length > 0) {
//           setIsFileParsingError({
//             status: true,
//             message:
//               "Some rows are missing required fields (First Name, Last Name, Mobile)",
//             isAttachementAvailable: true,
//             problematicData,
//           });
//           return;
//         }

//         // setStaffData(jsonData);
//         setStaffData(Array.isArray(jsonData[0]) ? jsonData[0] : jsonData);
//         setIsFileParsingError({
//           status: false,
//           message: "",
//           isAttachementAvailable: false,
//         });
//       } catch (error) {
//         setIsFileParsingError({
//           status: true,
//           message: "Error processing file: " + error.message,
//           isAttachementAvailable: false,
//         });
//       }
//     };
//     reader.readAsArrayBuffer(file);
//   };

//   const submitDataHandler = () => {
//     if (staffData.length > 1) {
//       setIsUploadClicked(true);
//     } else {
//       setIsFileParsingError({
//         status: true,
//         message: "No valid data to upload",
//         isAttachementAvailable: false,
//       });
//     }
//   };
//   // 00000000000000000000000000000000000000000000000000000000000

//   return (
//     <>
//       <Snackbar
//         open={isSuccess}
//         autoHideDuration={3000}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         onClose={() => setIsSuccess(false)}
//       >
//         <Alert
//           onClose={() => setIsSuccess(false)}
//           severity="success"
//           sx={{ width: "100%", backgroundColor: "rgba(42, 149, 69, 255)" }}
//         >
//           Data registered successfully
//         </Alert>
//       </Snackbar>

//       <Backdrop
//         sx={{ color: "rgba(34, 137, 203, 255)", zIndex: 99 }}
//         open={isLoading}
//       >
//         <CircularProgress color="inherit" />
//       </Backdrop>
//       <div className="trips-details" id="trip-table">
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <div style={{ display: "inline-block" }} className="title">
//             Staff Members
//           </div>
//           {localStorage.getItem("userType") !== "AccountManager" && (
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "20px",
//                 margin: "10px 20px",
//               }}
//             >
//               <Button
//                 size="small"
//                 onClick={() => {
//                   handleOpenModal();
//                 }}
//                 variant="contained"
//               >
//                 Add Staff
//               </Button>
//             </div>
//           )}
//         </div>
//         <div className="table-container-routes">
//           <div className="header">
//             <div style={{ display: "flex", gap: "10px", alignItems: "end" }}>
//               {localStorage.getItem("roleId") == "1" && (
//                 <CorporateFilter
//                   selectedCorporate={selectedCorporateDetails}
//                   setSelectedCorporate={setSelectedCorporateDetails}
//                   corporateData={corporateData}
//                   setCorporateData={setCorporateData}
//                   mainData={staff_details}
//                   setFilteredData={setFilteredData}
//                 />
//               )}

//               <div onChange={routeSearchHandler} className="route-search">
//                 <input placeholder="Search" type="text" ref={searchInputRef} />
//               </div>
//               <CSVLink
//                 data={staff_details}
//                 className="export_csv"
//                 filename={"data.csv"}
//               >
//                 Export
//               </CSVLink>
//             </div>
//           </div>
//           <Records
//             data={currentRecords}
//             headers={headers}
//             isLoading={isLoading}
//           />
//           <div>
//             <CommonTablePagination
//               page={page}
//               rowsPerPage={rowsPerPage}
//               setRowsPerPage={setRowsPerPage}
//               setPage={setPage}
//               filteredData={filteredData}
//               styling={{ display: "flex", justifyContent: "flex-end" }}
//             />
//           </div>
//         </div>
//       </div>

//       <Modal
//         open={modalOpen}
//         onClose={handleCloseModal}
//         aria-labelledby="modal-title"
//         aria-describedby="modal-description"
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             overflowX: "hidden",
//             transform: "translate(-50%, -50%)",
//             width: "30%",
//             maxHeight: "80vh",
//             overflowY: "auto",
//             bgcolor: "background.paper",
//             zIndex: "1500",
//             boxShadow: 24,
//             borderRadius: 4,
//             p: 3,
//           }}
//         >
//           <Box
//             sx={{
//               backgroundColor: "rgba(34, 137, 203, 255)",
//               color: "white",
//               borderTopLeftRadius: "10px",
//               borderTopRightRadius: "10px",
//               // p: 2,
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               margin: "-24px",
//               flexDirection: "row",
//             }}
//             style={{ padding: "0px 0px 0px 12px" }}
//           >
//             <Typography variant="h7" component="div">
//               Add Staff
//             </Typography>
//             <Button
//               onClick={handleCloseAddTaskModal}
//               sx={{ fontSize: "20px", color: "white" }}
//             >
//               x
//             </Button>
//           </Box>

//           <div style={{ marginTop: "10%" }}>
//             <Autocomplete
//               options={corporateData.map((data) => data.cpName)}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   label="Corporate"
//                   variant="standard"
//                   placeholder="Search Corporate Name"
//                   disabled={localStorage.getItem("roleID") !== "1"}
//                 />
//               )}
//               onChange={handleCorporateChange}
//               // value={selectedCorporateDetails.cpName}
//               value={
//                 localStorage.getItem("roleId") != 1
//                   ? localStorage.getItem("cpName")
//                   : selectedCorporateDetails.cpName
//               }
//             />

//             <Button
//               onClick={() => {
//                 history.push(
//                   `/student-staff-registration?name=${selectedCorporateDetails.cpName}&corpId=${selectedCorporateDetails.cpId}`
//                 );
//                 setModalOpen(false);
//               }}
//               disabled={
//                 !selectedCorporateDetails.cpName ||
//                 !selectedCorporateDetails.cpId
//               }
//               variant="contained"
//               sx={{ mt: 2, width: "100%" }}
//             >
//               Add Staff
//             </Button>

//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 margin: "20px 0",
//               }}
//             >
//               <div
//                 style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }}
//               ></div>
//               <div style={{ padding: "0 10px", color: "#666" }}>OR</div>
//               <div
//                 style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }}
//               ></div>
//             </div>

//             {/* {selectedCorporateDetails.cpName && ( */}
//             <>
//               <Button
//                 onClick={generateSampleExcel}
//                 variant="text"
//                 disabled={!stopList || !departmentList}
//                 color="primary"
//                 style={{
//                   padding: 0,
//                   textTransform: "none",
//                   marginBottom: "10px",
//                 }}
//               >
//                 Click here to download sample Excel file
//               </Button>

//               <TextField
//                 sx={{ marginTop: "10px", width: "100%" }}
//                 className="staff-data-file-input"
//                 type="file"
//                 onChange={fileChangeHandler}
//                 fullWidth
//               />

//               {isFileParsingError.status && (
//                 <div style={{ color: "red", marginTop: "10px" }}>
//                   {isFileParsingError.message}
//                   {isFileParsingError.isAttachementAvailable && (
//                     <Button
//                       onClick={() => {
//                         const ws = XLSX.utils.json_to_sheet(
//                           isFileParsingError.problematicData || []
//                         );
//                         const wb = XLSX.utils.book_new();
//                         XLSX.utils.book_append_sheet(wb, ws, "Error Data");
//                         XLSX.writeFile(wb, "error_data.xlsx");
//                       }}
//                       style={{
//                         marginLeft: "10px",
//                         color: "blue",
//                         textTransform: "none",
//                       }}
//                     >
//                       Download error details
//                     </Button>
//                   )}
//                 </div>
//               )}

//               <Button
//                 onClick={submitDataHandler}
//                 disabled={
//                   isFileParsingError.status == true || staffData?.length <= 1
//                 }
//                 variant="contained"
//                 sx={{ mt: 2, width: "100%" }}
//               >
//                 Bulk Upload
//               </Button>
//             </>
//           </div>
//         </Box>
//       </Modal>

//       {/* {isUploadClicked && (
//         <UploadBulkStaffData
//           staffData={staffData}
//           onClose={() => setIsUploadClicked(false)}
//         />
//       )} */}
//     </>
//   );
// }

// export default Routes;

import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useLocation, useHistory } from "react-router-dom";
import * as XLSX from "xlsx";
import Button from "../CommonComponent/Button";
import { Autocomplete, Box, Button as MuiButton, Modal, Paper, TextField, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import useHttp from "../../Hooks/use-http";
import CorporateFilter from "../CommonComponent/CorporateFilter";
import Records from "./Records";
import CommonTablePagination from "../CommonComponent/CommonTablePagination";
import { PAGINATIONBASEVALUE } from "../../Constant";
import PortalTitle from "../CommonComponent/PortalTitle";
import SearchFilter from "../CommonComponent/SearchFilter";

const STAFF_TITLE = [
  "Name",
  "Department",
  "Pickup Address",
  "Drop Address",
  "Status",
  "QR Code",
];

const STAFF_TITLE_WITH_CORPORATE = [
  "Name",
  "Corporate",
  "Department",
  "Pickup Address",
  "Drop Address",
  "Status",
  "QR Code",
];

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Routes() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGINATIONBASEVALUE);
  const [filteredData, setFilteredData] = useState([]);
  const [originalStaffData, setOriginalStaffData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isUploadFileClicked, setIsUploadFileClicked] = useState(false);
  const [isRequest, setIsRequest] = useState(false);
  const [corporateData, setCorporateData] = useState([]);
  const [headers, setHeaders] = useState(STAFF_TITLE);
  const [modalOpen, setModalOpen] = useState(false);
  const history = useHistory();
  const [selectedCorporateDetails, setSelectedCorporateDetails] = useState({
    cpName: "",
    cpId: "",
  });

  const [isFileParsingError, setIsFileParsingError] = useState({
    status: false,
    message: "",
  });
  const [isUploadClicked, setIsUploadClicked] = useState(false);
  const [staffData, setStaffData] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const [departmentList, setDepartmentList] = useState(null);
  const [stopList, setStopList] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRefereshData, setIsRefereshData] = useState(false);
  const search = useLocation().search;
  const id = new URLSearchParams(search).get("departmentId");

  useEffect(() => {
    if (localStorage.getItem("roleId") != 1) {
      setSelectedCorporateDetails({
        cpName: localStorage.getItem("cpName"),
        cpId: localStorage.getItem("corpId"),
      });
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("roleId") === "1") {
      setHeaders(STAFF_TITLE_WITH_CORPORATE);
    } else {
      setHeaders(STAFF_TITLE);
    }
  }, []);

  const { isLoading, sendRequest } = useHttp();

  const authenticateUser = (data) => {
    let staff_data = [];
    if (data?.corporateRiders) {
      for (let i = 0; i < data?.corporateRiders?.length; i++) {
        staff_data.push({
          id: i + 1,
          name: data.corporateRiders[i].riderName,
          mobile_no: data.corporateRiders[i].mobileNumber,
          status: data.corporateRiders[i]?.status,
          corporateName: data.corporateRiders[i].corporateName,
          departmentName: data.corporateRiders[i]?.dptName,
          pickupAddress: data.corporateRiders[i].pickupAddress,
          pickupRouteName: data.corporateRiders[i].PickupRouteName,
          pickupLL: data.corporateRiders[i].pickupLL,
          dropAddress: data.corporateRiders[i].dropAddress,
          dropRouteName: null,
          dropLL: data.corporateRiders[i].dropLL,
          corporateId: data.corporateRiders[i].corporateID,
          uniqueNumber: data.corporateRiders[i].uniqueNumber,
          RiderImage: data.corporateRiders[i].imageURL,
          parentID: data.corporateRiders[i].parentID,
        });
      }
    }
    setOriginalStaffData(staff_data);
    setFilteredData(staff_data);
  };

  useEffect(() => {
    sendRequest(
      {
        url: "/corporateriders",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: {
            filter: {
              corporateID:
                localStorage.getItem("roleId") != "1"
                  ? localStorage.getItem("corpId")
                  : selectedCorporateDetails?.[0]?.cpId || "",
            },
          },
        },
      },
      authenticateUser
    );
  }, [sendRequest, id, isRequest, isRefereshData]);

  useEffect(() => {
    if (selectedCorporateDetails.cpId) {
      sendRequest(
        {
          url: "/corporate",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              filter: {
                corporateID: selectedCorporateDetails.cpId,
              },
            },
          },
        },
        corporateStopDetails
      );
    }
  }, [sendRequest, selectedCorporateDetails.cpId]);

  const corporateStopDetails = (data) => {
    setDepartmentList(data?.departmentLists);
    setStopList(data?.ShuttleStopList);
  };

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  const handleCloseAddTaskModal = () => {
    setModalOpen(false);
  };

  const handleCorporateChange = (event, newValue) => {
    if (newValue) {
      const selectedData = corporateData.filter(
        (data) => data?.cpName === newValue
      );
      setSelectedCorporateDetails(selectedData[0] || { cpName: "", cpId: "" });
    } else {
      setSelectedCorporateDetails({ cpName: "", cpId: "" });
    }
  };

  const generateSampleExcel = async () => {
    if (!stopList || !departmentList) {
      setIsFileParsingError({
        status: true,
        message:
          "Corporate data is still loading. Please try again in a moment.",
        isAttachementAvailable: false,
      });
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Staff Data");

    worksheet.columns = [
      { header: "First Name", key: "firstName", width: 15 },
      { header: "Last Name", key: "lastName", width: 15 },
      {
        header: "Mobile Number",
        key: "mobile",
        width: 25,
      },
      {
        header: "Department (CorporateName(CorporateID))",
        key: "department",
        width: 30,
      },
      { header: "Address", key: "address", width: 25 },
      { header: "Pincode", key: "pincode", width: 10 },
      { header: "Area", key: "area", width: 15 },
      { header: "City", key: "city", width: 15 },
      { header: "State", key: "state", width: 15 },
      { header: "Pickup Stop", key: "pickupStop", width: 20 },
      { header: "Drop Stop", key: "dropStop", width: 20 },
      { header: "Pickup LatLng", key: "pickupLatLng", width: 15 },
      { header: "Drop LatLng", key: "dropLatLng", width: 15 },
    ];

    const stopSheet = workbook.addWorksheet("StopData");
    stopSheet.addRow(["StopName", "StopLL"]);
    stopList.forEach((stop) =>
      stopSheet.addRow([stop.StopName, stop.StopLatlong])
    );

    const departmentOptions = departmentList?.map(
      (dept) => `${dept.name}(${dept.corporateID})`
    );

    for (let row = 2; row <= 100; row++) {
      worksheet.getCell(`D${row}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${departmentOptions.join(",")}"`],
      };

      worksheet.getCell(`J${row}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`StopData!$A$2:$A$${stopList.length + 1}`],
      };

      worksheet.getCell(`K${row}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`StopData!$A$2:$A$${stopList.length + 1}`],
      };

      worksheet.getCell(`L${row}`).value = {
        formula: `IFERROR(VLOOKUP(J${row}, StopData!A:B, 2, FALSE), "")`,
      };
      worksheet.getCell(`M${row}`).value = {
        formula: `IFERROR(VLOOKUP(K${row}, StopData!A:B, 2, FALSE), "")`,
      };
    }

    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD3D3D3" },
      };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "staff_sample_data.xlsx");
  };

  const fileChangeHandler = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileExt = file.name.split(".").pop().toLowerCase();
    if (!["xlsx", "csv", "xls"].includes(fileExt)) {
      setIsFileParsingError({
        status: true,
        message: "Please upload file in xlsx, xls or csv format",
        isAttachementAvailable: false,
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array", cellFormula: true });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];

        // Get raw data including formulas
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: "",
          raw: false, // Get calculated values instead of formulas
        });

        // Validate headers
        const requiredHeaders = [
          "First Name",
          "Last Name",
          "Mobile Number",
          // "Department",
        ];
        const headers = jsonData[0]?.map((h) => h?.toString().trim()) || [];

        const missingHeaders = requiredHeaders.filter(
          (h) => !headers.includes(h)
        );
        if (missingHeaders.length > 0) {
          setIsFileParsingError({
            status: true,
            message: `Missing required columns: ${missingHeaders.join(", ")}`,
            isAttachementAvailable: false,
          });
          return;
        }

        const problematicData = [];
        const validData = [];

        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          const firstName = row[0]?.toString().trim();
          const lastName = row[1]?.toString().trim();
          const mobile = row[2]?.toString().trim();
          const department = row[3]?.toString().trim();

          // Skip completely empty rows
          if (!firstName && !lastName && !mobile && !department) {
            continue;
          }

          const corporateMatch = department?.match(/\(([^)]+)\)/);
          const corporateID = corporateMatch?.[1] || "";
          const corporateName = department?.replace(/\s*\([^)]*\)$/, "") || "";

          // Validate required fields
          if (
            !firstName ||
            !lastName ||
            !mobile ||
            !department ||
            !corporateID
          ) {
            problematicData.push({
              "Reason of Rejection": !mobile
                ? "Mobile number is required"
                : !department
                ? "Department is required"
                : !corporateID
                ? "Department must include Corporate ID in format: Name(ID)"
                : "First name and last name are required",
              "First Name": firstName || "",
              "Last Name": lastName || "",
              "Mobile Number": mobile || "",
              // Department: department || "",
            });
            continue;
          }

          // Validate mobile number format (digits only)
          if (!/^\d+$/.test(mobile)) {
            problematicData.push({
              "Reason of Rejection": "Mobile number must contain only digits",
              "First Name": firstName,
              "Last Name": lastName,
              "Mobile Number": mobile,
              // Department: department,
            });
            continue;
          }

          // Validate mobile number length
          if (mobile.length < 10 || mobile.length > 15) {
            problematicData.push({
              "Reason of Rejection": "Mobile number must be 10-15 digits",
              "First Name": firstName,
              "Last Name": lastName,
              "Mobile Number": mobile,
              // Department: department,
            });
            continue;
          }

          // Process pickup/drop locations
          const pickupStop = row[9]?.toString().trim() || "";
          const dropStop = row[10]?.toString().trim() || "";
          let pickupLL = row[11]?.toString().trim() || "";
          let dropLL = row[12]?.toString().trim() || "";

          // If latlng columns have formulas, they'll be evaluated by sheet_to_json with raw: false
          validData.push(row);
        }

        if (problematicData.length > 0) {
          setIsFileParsingError({
            status: true,
            message: `${problematicData.length} row(s) have errors - please fix before uploading`,
            isAttachementAvailable: true,
            problematicData,
          });
        } else {
          setIsFileParsingError({
            status: false,
            message: "",
            isAttachementAvailable: false,
          });
        }

        setStaffData(jsonData);
      } catch (error) {
        setIsFileParsingError({
          status: true,
          message: "Error processing file: " + error.message,
          isAttachementAvailable: false,
        });
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const submitDataHandler = () => {
    setIsSubmitting(true);

    if (staffData.length <= 1) {
      setIsFileParsingError({
        status: true,
        message: "No valid data to upload",
        isAttachementAvailable: false,
      });
      setIsSubmitting(false);
      return;
    }

    const payload = {
      emailID: localStorage.getItem("user"),
      detailsRecord: JSON.stringify(
        staffData
          .slice(1)
          .map((row) => {
            const department = row[3]?.toString().trim();
            const corporateMatch = department?.match(/\(([^)]+)\)/);
            const corporateID = corporateMatch?.[1] || "";
            const corporateName =
              department?.replace(/\s*\([^)]*\)$/, "") || "";

            return {
              CorporateID: corporateID,
              CorporateName: corporateName,
              StaffFirstName: row[0]?.toString().trim(),
              StaffLastName: row[1]?.toString().trim(),
              StaffMobileNumber: row[2]?.toString().trim(),
              Address: row[4]?.toString().trim() || "",
              Pincode: row[5]?.toString().trim() || "",
              Area: row[6]?.toString().trim() || "",
              City: row[7]?.toString().trim() || "",
              State: row[8]?.toString().trim() || "",
              PickupStop: row[9]?.toString().trim() || "",
              DropStop: row[10]?.toString().trim() || "",
              PickupLL: row[11]?.toString().trim() || "",
              DropLL: row[12]?.toString().trim() || "",
              CorporateType: "cp",
            };
          })
          .filter(
            (item) =>
              item.StaffFirstName &&
              item.StaffLastName &&
              item.StaffMobileNumber &&
              item.CorporateID
          )
      ),
    };

    sendRequest(
      {
        url: "/bulkAddRiders",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: payload,
      },
      addStaffDataResponse
    );
  };

  const addStaffDataResponse = (data) => {
    setIsSubmitting(false);

    if (data.ExistsTripList) {
      const problematicData = data.ExistsTripList.map((item) => ({
        "Reason of Rejection":
          item.reason || "Mobile Number already registered",
        "First Name": item.StaffFirstName,
        "Last Name": item.StaffLastName,
        "Mobile Number": item.StaffMobileNumber,
        "Corporate Name": item.CorporateName || "",
      }));

      setIsFileParsingError({
        status: true,
        message: data.message || "Some data could not be processed",
        isAttachementAvailable: true,
        problematicData,
      });
    } else if (data.status === "success") {
      setIsSuccess(true);
      setModalOpen(false);
      setIsUploadFileClicked(false);
      setIsRequest((prev) => !prev);
    } else {
      setIsFileParsingError({
        status: true,
        message: data.message || "An unknown error occurred",
        isAttachementAvailable: false,
      });
    }

    setIsUploadClicked(false);
  };

  const indexOfLastRecord = page * rowsPerPage + rowsPerPage;
  const indexOfFirstRecord = page * rowsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  return (
    <>
      <Snackbar
        open={isSuccess}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setIsSuccess(false)}
      >
        <Alert
          onClose={() => setIsSuccess(false)}
          severity="success"
          sx={{ width: "100%", backgroundColor: "rgba(42, 149, 69, 255)" }}
        >
          Data registered successfully
        </Alert>
      </Snackbar>

      <Backdrop
        sx={{ color: "rgba(34, 137, 203, 255)", zIndex: 99 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div className="trips-details" id="trip-table">
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="table-container-routes" style={{ margin: 0 }}>
            <Paper
              sx={{
                width: "100%",
                mb: 2,
                borderRadius: "10px",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                alignItems: "center",
                  px: 2,
                  pt: 1,
                  pb: 1,
                  borderRadius: "10px",
                  flexDirection: { xs: "column", md: "row" },
                  gap: { xs: 1, md: 0 },
              }}
            >
                <Box component="h2" sx={{ m: 0, display: "flex", alignItems: "center" }}>
                  <PortalTitle fallback="Staffs" />
                </Box>
        <Box
          sx={{
            display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    flexDirection: { xs: "column", md: "row" },
          }}
        >
                {localStorage.getItem("roleId") == "1" && (
                  <CorporateFilter
                    selectedCorporate={selectedCorporateDetails}
                    setSelectedCorporate={setSelectedCorporateDetails}
                    corporateData={corporateData}
                    setCorporateData={setCorporateData}
                    mainData={originalStaffData}
                    setFilteredData={setFilteredData}
                    setIsRefereshData={setIsRefereshData}
                  />
                )}

                <SearchFilter
                  data={originalStaffData}
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                  setFilteredData={setFilteredData}
                  loading={isLoading}
                  placeholder="Search"
                />
                <CSVLink
                  data={filteredData}
                  filename={"staff_data.csv"}
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <MuiButton
                      variant="outlined"
                      sx={{
                        color: "#1D85C6",
                        border: "1px solid #1D85C6",
                        ":hover": {
                          border: "1px solid #1D85C6",
                          color: "black",
                        },
                      }}
                      size="small"
                >
                  Export
                    </MuiButton>
                </CSVLink>
                  {localStorage.getItem("userType") !== "AccountManager" && (
                    <Button
                      size="small"
                      onClick={handleOpenModal}
                      variant="contained"
                      sx={{
                        backgroundColor: "#44B150",
                        ":hover": {
                          backgroundColor: "#44B150",
                          opacity: 0.8,
                        },
                      }}
                    >
                      Add Staff
                    </Button>
                  )}
                </Box>
              </Box>

            <Records
              data={filteredData}
              setFilteredData={setFilteredData}
              headers={headers}
              isLoading={isLoading}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
            />

            {/* <div>
            <CommonTablePagination
              page={page}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setPage={setPage}
              filteredData={filteredData}
              styling={{ display: "flex", justifyContent: "flex-end" }}
            />
          </div> */}
            </Paper>
          </div>
        </Box>
      </div>

      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            overflowX: "hidden",
            transform: "translate(-50%, -50%)",
            width: "30%",
            maxHeight: "80vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            zIndex: "1500",
            boxShadow: 24,
            borderRadius: 4,
            p: 3,
          }}
        >
          <Box
            sx={{
              backgroundColor: "rgba(34, 137, 203, 255)",
              color: "white",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "-24px",
              flexDirection: "row",
            }}
            style={{ padding: "0px 0px 0px 12px" }}
          >
            <Typography variant="h7" component="div">
              Add Staff
            </Typography>
            <Button
              onClick={handleCloseAddTaskModal}
              sx={{ 
                fontSize: "24px", 
                color: "white",
                backgroundColor: "#d32f2f",
                minWidth: "auto",
                padding: "0px 12px",
                "&:hover": {
                  backgroundColor: "#b71c1c",
                },
              }}
            >
              ×
            </Button>
          </Box>

          <div style={{ marginTop: "10%" }}>
            <Autocomplete
              options={corporateData.map((data) => data.cpName)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Corporate"
                  variant="standard"
                  placeholder="Search Corporate Name"
                  disabled={localStorage.getItem("roleID") !== "1"}
                />
              )}
              onChange={handleCorporateChange}
              value={
                localStorage.getItem("roleId") != 1
                  ? localStorage.getItem("cpName")
                  : selectedCorporateDetails.cpName
              }
            />

            <Button
              onClick={() => {
                history.push(
                  `/student-staff-registration?name=${selectedCorporateDetails.cpName}&corpId=${selectedCorporateDetails.cpId}`
                );
                setModalOpen(false);
              }}
              disabled={
                !selectedCorporateDetails.cpName ||
                !selectedCorporateDetails.cpId
              }
              variant="contained"
              sx={{ mt: 2, width: "100%" }}
            >
              Add Staff
            </Button>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "20px 0",
              }}
            >
              <div
                style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }}
              ></div>
              <div style={{ padding: "0 10px", color: "#666" }}>OR</div>
              <div
                style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }}
              ></div>
            </div>

            <Button
              onClick={generateSampleExcel}
              variant="text"
              disabled={!stopList || !departmentList}
              color="primary"
              style={{
                padding: 0,
                textTransform: "none",
                marginBottom: "10px",
              }}
            >
              Click here to download sample Excel file
            </Button>

            <TextField
              sx={{ marginTop: "10px", width: "100%" }}
              className="staff-data-file-input"
              type="file"
              onChange={fileChangeHandler}
              fullWidth
            />

            {isFileParsingError.status && (
              <div style={{ color: "red", marginTop: "10px" }}>
                {isFileParsingError.message}
                {isFileParsingError.isAttachementAvailable && (
                  <Button
                    onClick={() => {
                      const ws = XLSX.utils.json_to_sheet(
                        isFileParsingError.problematicData || []
                      );
                      const wb = XLSX.utils.book_new();
                      XLSX.utils.book_append_sheet(wb, ws, "Error Data");
                      XLSX.writeFile(wb, "error_data.xlsx");
                    }}
                    style={{
                      marginLeft: "10px",
                      color: "blue",
                      textTransform: "none",
                    }}
                  >
                    Download error details
                  </Button>
                )}
              </div>
            )}

            <Button
              onClick={submitDataHandler}
              disabled={
                isFileParsingError.status === true ||
                staffData?.length <= 1 ||
                isSubmitting
              }
              variant="contained"
              sx={{ mt: 2, width: "100%" }}
            >
              {isSubmitting ? "Uploading..." : "Bulk Upload"}
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default Routes;
